import PropTypes from 'prop-types';
import classnames from 'classnames';

import './ListingEnergyCertificateValue.scss';

const ListingEnergyCertificateValue = ({ value, squared = false }) => {
  const className = classnames(
    'listing-energy-certificate-value',
    `listing-energy-certificate-value--${value}`,
    {
      'listing-energy-certificate-value--squared': squared
    }
  );

  return <div className={className}>{value}</div>;
};

ListingEnergyCertificateValue.propTypes = {
  value: PropTypes.string.isRequired,
  squared: PropTypes.bool
};

export default ListingEnergyCertificateValue;
